export const MAX_INTERPRETED_EXPS = 50000;
export const MAX_IMAGES = 3000;
export const MAX_STEPS_IN_INSTR = 1000;
